// Widget Scripts
import headerButton from './js/widgets/headerButton.js';
import vimeoWidget from './js/widgets/vimeoWidget.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import edgeCards from './js/widgets/edgeCardsWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import standardCards from './js/widgets/standardCardsWidget.js';
import sponsors from './js/widgets/sponsors.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function () {
    vimeoWidget();
    eventsWidget();
    edgeCards();
    seoWidget();
    standardCards();
    sponsors();
  });
}

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  headerButton();
});
